import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { TeamPicker } from './TeamPicker';

export const TeamPickerExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'TeamPicker',
        // @ts-ignore
        component: TeamPicker,
    }),
);
